<template>
  <button
    class="button"
    :data-radius="radius"
    :data-style="styling"
    :data-variant="variant"
    :data-size="size"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    radius: {
      type: String,
      required: false,
      default: "",
    },
    styling: {
      type: String,
      required: false,
      default: "",
    },
    variant: {
      type: String,
      required: false,
      default: "",
    },
    size: {
      type: String,
      required: false,
      default: "",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {},
};
</script>

<style lang="scss">
// Coloring exceptions
@mixin button-coloring {
  &[data-style="light"] {
    --button-background-color: var(--color-shade-light);
    --button-border-color: var(--color-shade-light);
    --button-color: var(--color-shade-dark);

    &:hover,
    &:focus,
    &:active {
      --button-background-color: var(--color-shade-light-glare);
    }
  }

  &[data-style="bad"] {
    --button-background-color: var(--color-state-bad);
    --button-border-color: var(--color-state-bad);
    --button-color: var(--color-shade-light);

    &:hover,
    &:focus,
    &:active {
      --button-background-color: var(--color-state-bad-glare);
    }
  }
}

// Variants exceptions
@mixin button-variants {
  &[data-variant="outline"] {
    --button-color: var(--button-background-color);
    --button-border-color: currentColor;
    --outline-offset: 2px; // Outline offset for :focus styles
    background: transparent;
  }

  &[data-variant="clear"] {
    --button-color: var(--button-background-color);
    --outline-offset: 2px; // Outline offset for :focus styles
    border-color: transparent;
    background: transparent;
  }
}

// Sizing exceptions
@mixin button-sizing {
  &[data-size="small"] {
    font-size: var(--size--2);
  }

  &[data-size="large"] {
    font-size: var(--size-0);
  }
}

.button {
  --button-background-color: var(--color-shade-dark);
  --button-border-color: transparent;
  --button-color: var(--color-shade-light);
  --outline-offset: -6px; // Outline offset for :focus styles
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-block: var(--size--3);
  padding-inline: var(--size--1);
  min-height: 44px;
  border: var(--border-thin) solid var(--button-border-color);
  outline: 0;
  background-color: var(--button-background-color);
  text-decoration: none;
  font: inherit;
  font-size: var(--size--1);
  line-height: var(--leading-flat);
  color: var(--button-color);
  cursor: pointer;
  transition: background-color var(--timing-normal) ease-out;

  &:hover,
  &:active {
    --button-background-color: var(--color-shade-dark-glare);
  }

  // Disabled buttons
  &[disabled] {
    pointer-events: none;
    opacity: .5;
  }

  // Coloring
  @include button-coloring;

  // Variants
  @include button-variants;

  // Sizing
  @include button-sizing;

  // Radius exception
  &[data-radius="true"] {
    border-radius: var(--radius-medium);
  }
}
</style>
